/** Returns PrimeIcons classes for a file upload row based on the file extension. */
export function uploadFileIconClass(fileName: string): string {
  const name = fileName.toLowerCase();
  if (name.endsWith('.pdf')) {
    return 'pi pi-file-pdf text-xl! shrink-0';
  }
  if (
    name.endsWith('.xls') ||
    name.endsWith('.xlsx') ||
    name.endsWith('.csv')
  ) {
    return 'pi pi-file-excel text-xl! shrink-0';
  }
  if (
    name.endsWith('.doc') ||
    name.endsWith('.docx') ||
    name.endsWith('.txt')
  ) {
    return 'pi pi-file-word text-xl! shrink-0';
  }
  if (
    name.endsWith('.jpg') ||
    name.endsWith('.jpeg') ||
    name.endsWith('.png') ||
    name.endsWith('.gif') ||
    name.endsWith('.webp')
  ) {
    return 'pi pi-image text-xl! shrink-0';
  }
  return 'pi pi-file text-xl! shrink-0';
}
